import { reportRetentionsExistsTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_RETENTIONS_EXISTS_FILTERS,
  RESTORE_INITIAL
} = reportRetentionsExistsTypes;

const initialState = {
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportRetentionsExistsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_RETENTIONS_EXISTS_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return initialState;

    default:
      return state;
  }
};
